import { jsx as _jsx } from "react/jsx-runtime";
import { FontWeights, merge, Text, } from '@fluentui/react';
import { useThemeData } from '@msrceng/theme';
/**
 * A tag component, which includes the rectangular color-controllable
 * background and frame around a short bit of text content.
 *
 * This is similar to tags seen on ADO and other common UXs),
 * but this one is not dependent on being inside somebody else's
 * Combobox or TagInput larger control.
 */
export const Tag = ({ children, styles, color, background }) => {
    var _a;
    const { theme } = useThemeData();
    return (_jsx(Text, Object.assign({ styles: merge({}, {
            root: {
                background: background || (theme === null || theme === void 0 ? void 0 : theme.palette.neutralLight),
                borderRadius: (_a = theme === null || theme === void 0 ? void 0 : theme.effects) === null || _a === void 0 ? void 0 : _a.roundedCorner4,
                color: color || (theme === null || theme === void 0 ? void 0 : theme.palette.neutralSecondary),
                // fontSize: '.625rem',
                fontWeight: FontWeights.semibold,
                margin: '0 0 0 .25rem',
                padding: '.13rem .3rem',
            },
        }, styles) }, { children: children })));
};
